<div class="gauge-graph-table-header text">
    <div class="col-no column">
        {{ 'graph.gauge.table.header.number' | translate }}
    </div>
    <div class="col-channel column">
        {{ 'graph.gauge.table.header.channel' | translate }}
    </div>
    <div class="col-scale-division column">
        {{ 'graph.gauge.table.header.scale-division' | translate }}
        <div class="config-info-message">
            <mat-icon
                svgIcon="info"
                class="info-icon"
                (mouseenter)="isInfoMessageVisible = true"
                (mouseleave)="isInfoMessageVisible = false"></mat-icon>
            <ng-container *ngIf="isInfoMessageVisible">
                <div #infoMessage class="info-message-container">
                    <div>
                        {{ 'graph.gauge.table.scale-division.info.text' | translate }}
                    </div>
                </div>
            </ng-container>
        </div>
    </div>
    <div class="col-options column"></div>
</div>
